import { render, staticRenderFns } from "./request-responder.vue?vue&type=template&id=06c2624c&scoped=true"
import script from "./request-responder.vue?vue&type=script&lang=ts"
export * from "./request-responder.vue?vue&type=script&lang=ts"
import style0 from "./request-responder.vue?vue&type=style&index=0&id=06c2624c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2624c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c2624c')) {
      api.createRecord('06c2624c', component.options)
    } else {
      api.reload('06c2624c', component.options)
    }
    module.hot.accept("./request-responder.vue?vue&type=template&id=06c2624c&scoped=true", function () {
      api.rerender('06c2624c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pledge-accounting-request/request-responder.vue"
export default component.exports